import VR from '@components/LocalMerchant/VR/Detail'
import Hotspot from './Hotspot'
import Info from './Info'
import View from './View'
import { VR_INFO_PATH } from '@constant'

export default {
  path: 'manage',
  component: VR,
  indexRoute: {
    onEnter(ns, replace) {
      replace(`${VR_INFO_PATH}?id=28`)
    }
  },
  stat: '全景管理/首页',
  childRoutes: [Hotspot, Info, View]
}
